import { render } from "./downloadPaper.vue?vue&type=template&id=4a6e2518&scoped=true"
import script from "./downloadPaper.vue?vue&type=script&lang=js"
export * from "./downloadPaper.vue?vue&type=script&lang=js"

import "./downloadPaper.vue?vue&type=style&index=0&id=4a6e2518&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6e2518"]])

export default __exports__